// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3CIWB","select":"Header_select__3yW48","clinic":"Header_clinic__YEZrm"};